import { CartNoteAttributes, CartNoteConfigType, CartNotePayload } from "lib/types/cartNotes";
import { AddOnMetaType, AddOnType, NoteAttributesType } from "lib/types/checkout";

export const createPayload = (
  inputValue: string,
  action: "ADD" | "DELETE" | "EDIT",
  cartNoteAttributes: CartNoteAttributes,
): CartNotePayload => {
  if (cartNoteAttributes.type === "FREE") {
    return {
      note: action === "DELETE" ? null : inputValue
    };
  } else if (cartNoteAttributes.type === "PAID") {
    return {
      addon_id: cartNoteAttributes?.cartNoteAddOnData?.addonId ?? "",
      note: inputValue,
      addon_level: "CART",
    };
  }
  return {};
};

export const getCartNoteType = (
  availableAddOns: Record<string, AddOnMetaType>,
  freeCartNote: CartNoteConfigType,
): CartNoteAttributes => {
  const paidNote = Object.values(availableAddOns).find((addOn) => addOn.addon_type === "CART_NOTE");
  const hasFreeNote = freeCartNote?.enabled;

  if (paidNote) {
    return {
      hasCartNote: true,
      type: "PAID",
      cartNoteConfig: {
        enabled: true,
        title: paidNote?.metadata?.title || "Add a note",
        suggestionText: paidNote?.metadata?.suggestion_text || "Add any specific instructions or requests...",
        icon: paidNote?.metadata?.icon || "EDIT",
      },
      cartNoteAddOnData: {
        addonId: paidNote?.addon_id,
        addonType: paidNote?.addon_type,
        price: paidNote?.price,
      },
    };
  } else if (hasFreeNote) {
    return {
      hasCartNote: freeCartNote?.enabled ?? false,
      type: "FREE",
      cartNoteConfig: {
        enabled: true,
        title: freeCartNote?.title || "Add a note",
        suggestionText: freeCartNote?.suggestionText || "Add any specific instructions or requests...",
        icon: freeCartNote?.icon || "EDIT",
      },
    };
  }

  return {
    hasCartNote: false,
    type: "NONE",
    cartNoteConfig: {
      enabled: false,
      title: "",
      suggestionText: "",
      icon: "EDIT",
    }
  };
};

export const getAppliedCartNote = (note: string, appliedCartAddOns: AddOnType[]) => {
  const paidCartNote = appliedCartAddOns.find((note) => note.addon_type === "CART_NOTE");
  const freeCartNote = note;

  if (paidCartNote) {
    return {
      hasCartNoteAdded: true,
      type: "PAID",
      note: paidCartNote?.note ?? "",
    };
  } else if (freeCartNote) {
    return {
      hasCartNoteAdded: Boolean(freeCartNote),
      type: "FREE",
      note: freeCartNote ?? "",
    };
  }
  return {
    hasCartNoteAdded: false,
    type: "NONE",
    note: "",
  };
};
